import React from 'react';

export default function Home() {
  return <p style={{ padding: '10px' }}>Nothing to see here</p>;
}
